import { useState } from 'react'

interface ProjectLogoProps {
  logo?: string | null
  alt: string
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'w-7 h-7',
  md: 'w-8 h-8',
  lg: 'w-10 h-10'
}

const textSizeClasses = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base'
}

export const ProjectLogo = ({ logo, alt, size = 'sm' }: ProjectLogoProps) => {
  const [imgError, setImgError] = useState(false)
  const sizeClass = sizeClasses[size]
  const textSizeClass = textSizeClasses[size]
  
  return (
    <div className={`${sizeClass} rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center flex-shrink-0`}>
      {!imgError && logo ? (
        <img
          src={logo}
          alt={alt}
          className={`${sizeClass} rounded-full object-cover`}
          onError={() => setImgError(true)}
        />
      ) : (
        <div className={`${sizeClass} rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center`}>
          <span className={`${textSizeClass} font-medium text-gray-500 dark:text-gray-400`}>
            {alt.charAt(0).toUpperCase()}
          </span>
        </div>
      )}
    </div>
  )
}

